import React from "react";
import Button from "react-bootstrap/Button";
import { withRouter } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Joi from "joi-browser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dots from "react-activity/lib/Dots";
import FormState from "./common/formstate";
import plane from "../images/plane_icon2.png";
import { getCurrentUser } from "../services/authService";
import { saveImage } from "../services/aircraftImageService";
import { saveAircraft, deleteAircraft } from "../services/aircraftService";
import { getById } from "../services/aircraftService";
import { getMainImage, deleteImage } from "../services/aircraftImageService";
import {
	getAircraftGroups,
	saveAircraftGroup,
} from "../services/aircraftGroupService";
import { getCountriesOfManufacturer } from "../services/aircraftService";

class AircraftForm extends FormState {
	state = {
		data: {
			aircraft_name: "",
			year_of_manufacture: "",
			country_of_manufacturer: "",
			operators_during_wwii: "",
			primary_group_id: 0,
			wikilink: "",
		},
		errors: {},
		aircraftGroups: [],
		countries: [],
		base64TextString: "",
		aircraft_image_format: "",
		aircraft_image: "",
		aircraft_image_id: 0,
		image_width: 0,
		image_height: 0,
		action: "add",
		user: {},
		loaded: true,
	};

	schema = {
		aircraft_name: Joi.string().label("Aircraft Name").required().max(100),
		wikilink: Joi.string()
			.label("Wikilink")
			// eslint-disable-next-line
			.regex(
				/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/
			)
			.optional()
			.allow("")
			.max(1000),
		primary_group_id: Joi.number()
			.label("Aircraft Type")
			.required()
			.error(() => {
				return {
					message: "Aircraft type is required.",
				};
			}),
		year_of_manufacture: Joi.number()
			.label("Year Of Manufacture")
			.min(1900)
			.max(2000)
			.required(),
		country_of_manufacturer: Joi.string()
			.label("Country of Manufacturer")
			.required()
			.max(45),
		operators_during_wwii: Joi.string()
			.label("Operators during WWII")
			.required()
			.max(200),
		owner_id: Joi.number().optional(),
		aircraft_id: Joi.number().optional(),
		createdAt: Joi.date().optional(),
		updatedAt: Joi.date().optional(),
	};

	async populateLists() {
		const aircraftGroups = await getAircraftGroups();
		const countries = await getCountriesOfManufacturer();

		this.setState({ aircraftGroups, countries });
	}

	async componentDidMount() {
		this.setState({ loaded: false });
		await this.populateLists();

		const user = getCurrentUser();
		const items = this.props.location.pathname.split("/");

		if (items[2] === "add") {
			this.setState({ user, loaded: true });
			return;
		}

		const aircraft_id = items[3];

		const aircraft = await getById(aircraft_id);

		if (aircraft) {
			const img = await getMainImage(aircraft_id);
			if (img)
				this.setState({
					data: aircraft,
					aircraft_image: img.aircraft_image,
					aircraft_image_format: img.aircraft_image_format,
					aircraft_image_id: img.image_id,
					image_width: img.image_width,
					image_height: img.image_height,
					action: "edit",
					user,
					loaded: true,
				});
			else
				this.setState({ data: aircraft, action: "edit", user, loaded: true });
		} else this.setState({ user, loaded: true });

		document.getElementById("aircraft_name").focus();
	}

	onFileChange(e) {
		const file = e.target.files[0];

		if (file) {
			if (file.size > 2097152) {
				toast.error("The image is too large to upload. 2MB maximum.");
				e.value = "";
				return;
			}
			const aircraft_image_format = file.name.split(".").pop();
			this.setState({ aircraft_image_format });

			const reader = new FileReader();
			reader.onload = this._handleReaderLoaded.bind(this);
			reader.readAsBinaryString(file);
		}
	}

	handleShowAircraftDetails = (aircraft_id) => {
		this.props.history.push(`/aircraft/details/${aircraft_id}`);
	};

	handleWikiChange = (e) => {
		this.setState({ wikilink: e.target.value });
	};

	_handleReaderLoaded(readEvt) {
		let binaryString = readEvt.target.result;
		const base64String = btoa(binaryString);

		const format = this.state.aircraft_image_format;
		const pic = document.getElementById("plane-picture");

		pic.src = "data:image/" + format + ";base64," + base64String;
		pic.width = 300;

		this.setState({
			base64TextString: base64String,
		});
	}

	onImgLoad = ({ target: img }) => {
		this.setState({
			image_height: img.naturalHeight,
			image_width: img.naturalWidth,
		});
	};

	handleCancel() {
		this.props.history.push("/search/aircraft");
	}

	async handleDelete(aircraft_id) {
		await deleteAircraft(aircraft_id);
		this.props.history.push("/search/aircraft");
	}

	async handleDeleteImage(aircraft_image_id) {
		await deleteImage(aircraft_image_id);

		this.setState({
			aircraft_image: "",
			aircraft_image_format: "",
			aircraft_image_id: 0,
			image_width: 0,
			image_height: 0,
		});
	}

	handleAddAircraft() {
		const data = {};
		data.aircraft_name = "";
		data.year_of_manufacture = "";
		data.country_of_manufacturer = "";
		data.operators_during_wwii = "";
		data.primary_group_id = "";
		data.wikilink = "";

		this.setState({ data: data, action: "add" });
		document.getElementById("aircraft_name").focus();
	}

	handleShowModels = (aircraft_id) => {
		this.props.history.push("/models", { params: aircraft_id });
	};

	handleAddAircraftType = async () => {
		const aircratType = window.prompt("Enter the Aircraft Type:");
		if (aircratType != null) {
			const data = {
				group_name: aircratType.toUpperCase(),
				owner_id: this.state.user.id,
			};
			await saveAircraftGroup(data);
			const aircraftGroups = await getAircraftGroups();

			this.setState({ aircraftGroups });
			window.alert("Aircraft type added to list successfully!");
		}
	};

	async doSubmit() {
		const {
			base64TextString: base64String,
			aircraft_image_format,
			data: aircraft,
			image_width,
			image_height,
			user,
		} = this.state;

		if (aircraft.aircraft_id === undefined) {
			aircraft.owner_id = user.id;
		} else {
			delete aircraft.createdAt;
			delete aircraft.updateAt;
		}

		const result = await saveAircraft(aircraft);

		if (base64String.length > 0 && result.aircraft_id) {
			let payload = {};
			payload.aircraft_image = base64String;
			payload.aircraft_image_format = aircraft_image_format;
			payload.aircraft_id = result.aircraft_id;
			payload.image_width = image_width;
			payload.image_height = image_height;
			payload.show_main_image = true;
			payload.owner_id = user.id;
			saveImage(payload);
		}

		this.props.history.push("/models", { params: result.aircraft_id });
	}

	render() {
		const {
			action,
			data: aircraft,
			aircraft_image,
			aircraft_image_format,
			aircraft_image_id,
			loaded,
		} = this.state;

		let title = "";
		let btnShow = {};
		let btnAdd = {};
		if (action === "add") {
			title = "Add Aircraft";
			btnShow = null;
			btnAdd = null;
		} else {
			title = "";
			btnShow = (
				<Button
					variant="link"
					size="lg"
					onClick={() => this.handleShowAircraftDetails(aircraft.aircraft_id)}
				>
					{aircraft.aircraft_name}
				</Button>
			);
			btnAdd = (
				<Button variant="primary" onClick={() => this.handleAddAircraft()}>
					Add
				</Button>
			);
		}

		let img = "";
		if (aircraft_image)
			img = "data:image/" + aircraft_image_format + ";base64," + aircraft_image;
		else img = plane;

		return loaded === false ? (
			<div className="dots_loader">
				<Dots size={26} />
			</div>
		) : (
			<div
				style={{
					marginBottom: 100,
					border: "1px solid darkgray",
					padding: "25px",
					borderRadius: "5px",
				}}
			>
				<ToastContainer></ToastContainer>
				<div className="row">
					<div className="col-8" style={{ backgroundColor: "white" }}>
						<h5>
							<FontAwesomeIcon icon="plane" />
							&nbsp;{title}
							{btnShow}
						</h5>
					</div>
					<div className="col-4" style={{ textAlign: "right" }}>
						{action === "edit" ? (
							<Button
								variant="link"
								onClick={() => this.handleShowModels(aircraft.aircraft_id)}
							>
								Brand Models
							</Button>
						) : null}
					</div>
				</div>
				<form onSubmit={this.handleSubmit}>
					<table className="formTable">
						<tbody>
							<tr>
								<td colSpan="2">
									{this.renderInput(
										"aircraft_name",
										"Aircraft Name",
										"pencil-alt"
									)}
								</td>
							</tr>
							<tr>
								<td>
									{this.renderInput(
										"year_of_manufacture",
										"Year Of Manufacture",
										"calendar-alt"
									)}
								</td>
								<td>
									{this.renderInputAndSelect(
										"country_of_manufacturer",
										"Country Of Manufacturer (select or type a country)",
										"flag-usa",
										this.state.countries,
										"country_of_manufacturer",
										"country_of_manufacturer"
									)}
								</td>
							</tr>
							<tr>
								<td colSpan="2">
									{this.renderInput(
										"operators_during_wwii",
										"Operators during WWII",
										"user-friends"
									)}
								</td>
							</tr>
							<tr>
								<td colSpan="2">
									{this.renderInput("wikilink", "Wikilink", "link")}
								</td>
							</tr>
							<tr>
								<td>
									{this.renderSelect(
										"primary_group_id",
										"Aircraft Type",
										this.state.aircraftGroups,
										"group_id",
										"group_name",
										"plane"
									)}
									<Button
										variant="primary"
										onClick={this.handleAddAircraftType}
									>
										Add
									</Button>
								</td>
								<td colSpan="1" style={{ textAlign: "center" }}>
									<img
										src={img}
										alt="aircraft"
										id="plane-picture"
										className="aircraftFormPhoto"
										onLoad={this.onImgLoad}
										style={{ marginRight: 20 }}
									/>
									<input
										type="file"
										name="btnBrowse"
										accept=".jpeg, .png, .jpg"
										onChange={(e) => this.onFileChange(e)}
									></input>
								</td>
							</tr>
							<tr>
								<td colSpan="2">
									{btnAdd}&nbsp;&nbsp;
									<button className="btn btn-primary">Save</button>&nbsp;&nbsp;
									<Button
										variant="primary"
										onClick={() => {
											if (
												window.confirm(
													"Are you sure you wish to delete this aircraft and all its models?"
												)
											)
												this.handleDelete(aircraft.aircraft_id);
										}}
									>
										Delete
									</Button>
									&nbsp;&nbsp;
									<Button variant="primary" onClick={() => this.handleCancel()}>
										Cancel
									</Button>
									&nbsp;&nbsp;
									<Button
										variant="primary"
										onClick={() => this.handleDeleteImage(aircraft_image_id)}
									>
										Delete Photo
									</Button>
								</td>
							</tr>
						</tbody>
					</table>
				</form>
			</div>
		);
	}
}

export default withRouter(AircraftForm);
